<template>
  <div v-if="!error404" class="container-fluid">
    <div class="page-header min-height-300 border-radius-xl mt-4 opacity-6 justify-content-center">
      <img alt="" :src="require('@/assets/img/logo-black.svg')" class="w-50">
      <span class="mask bg-gradient-success"></span>
    </div>
    <div class="card card-body mx-3 mx-md-4 mt-n6">
      <div class="row gx-4">
        <div class="col-auto">
          <card-account-details-outline-icon :size=70 fillColor="currentColor"/>
        </div>
        <div class="col-auto my-auto">
          <div class="h-100">
            <h5 class="mb-1">{{ this.client.name }}</h5>
            <p class="mb-0 font-weight-normal text-sm">
              {{ this.client.title }}
            </p>
          </div>
        </div>
        <div class="mx-auto mt-3 col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0">
          <div class="nav-wrapper position-relative end-0 d-flex">
            <!--<material-button
              class="my-4 mb-2"
              variant="gradient"
              color="danger"
              type="submit"
            >Деактивировать
            </material-button>-->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="mt-3 row">
          <div class="col-12 col-md-6 col-xl-6 mt-md-0 mt-4 position-relative">
            <div class="h-100">
              <div class="p-3 pb-0 card-header"></div>
              <div class="p-3 card-body">
                <ul class="list-group">
                  <li class="text-sm border-0 list-group-item ps-0">
                    <strong class="text-dark">ID:</strong>
                    &nbsp;{{ client.id }}
                  </li>
                  <li class="text-sm border-0 list-group-item ps-0">
                    <strong class="text-dark">Дата создания:</strong>
                    &nbsp;{{ formatDate(client.created) }}
                  </li>
                  <li class="text-sm border-0 list-group-item ps-0">
                    <strong class="text-dark">Дата редактирования:</strong>
                    &nbsp;{{ formatDate(client.updated) }}
                  </li>
                  <li class="text-sm border-0 list-group-item ps-0">
                    <strong class="text-dark">Логин:</strong>
                    &nbsp;{{ client.login }}
                  </li>
                </ul>
                <form role="form" class="text-start mt-3" @submit.prevent="updateClient">
                  <fieldset :disabled="formDisable">
                    <div class="mb-3">
                      <material-input
                        id="client_name"
                        type="text"
                        label="Имя"
                        name="client_name"
                        :isRequired=true
                        v-model="client.name"
                        value="{{ client.name }}"
                      />
                    </div>
                    <div class="mb-3 client-password">
                      <material-input
                        id="client_new_password"
                        :type="showPassword ? 'text' : 'password'"
                        label="Новый пароль"
                        name="client_new_password"
                        :isRequired=false
                        v-model="client.password"
                        value="{{client.password}}"
                      />
                      <div class="client-password_actions">
                        <a
                          href="javascript:void(0)"
                          @click.prevent="generatePassword">
                          <key-plus-icon />
                        </a>
                        <a
                          href="javascript:void(0)"
                          @click.prevent="visiblePassword">
                          <eye-icon v-if="showPassword"/>
                          <eye-off-icon v-if="!showPassword"/>
                        </a>
                      </div>
                    </div>
                    <div class="my-4">
                      <div class="d-flex flex-row align-items-center">
                        <material-button
                          variant="gradient"
                          color="success"
                          type="submit">
                          Сохранить
                        </material-button>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
            <hr class="vertical dark"/>
          </div>
          <div class="col-12 col-md-6 col-xl-6 mt-md-0 mt-4 position-relative">
            <Licenses/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <NotFound/>
  </div>
</template>

<script>
import axios from "axios"

import MaterialInput from "@/components/MaterialInput.vue"
import MaterialButton from "@/components/MaterialButton.vue"
import Licenses from "./components/client/Licenses.vue"
import NotFound from "./NotFound.vue"

import CardAccountDetailsOutlineIcon from "vue-material-design-icons/CardAccountDetailsOutline.vue"
import EyeIcon from "vue-material-design-icons/Eye.vue"
import EyeOffIcon from "vue-material-design-icons/EyeOff.vue"
import KeyPlusIcon from "vue-material-design-icons/KeyPlus.vue"

import setTooltip from "@/assets/js/tooltip.js"
import {API_HOST} from "@/config"

const charsList = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"

export default {
  name: "Client",
  inject: ["notification"],
  data() {
    return {
      formDisable: false,
      error404: false,
      client: {},
      showPassword: false,
      hasPassword: false,
    }
  },
  components: {
    Licenses,
    MaterialInput,
    MaterialButton,
    CardAccountDetailsOutlineIcon,
    EyeIcon,
    EyeOffIcon,
    KeyPlusIcon,
    NotFound,
  },
  methods: {
    generatePassword() {
      let password = '';
      for(let i = 0; i < 12; i++){
        const charIndex = Math.round(Math.random() * charsList.length);
        password += charsList.charAt(charIndex);
      }

      this.showPassword = true
      this.client.password = password;
    },
    visiblePassword() {
      this.showPassword = !this.showPassword
    },
    formatDate(dateString) {
      const options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      }
      return new Date(dateString).toLocaleDateString("ru-RU", options)
    },
    loadClient() {
      axios
        .get(API_HOST + "/v1/manager/client/" + this.$route.params.id, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + this.$store.getters.getTokenPair.access,
          },
        })
        .then((response) => {
          this.client = response.data

          this.$store.commit("setBreadcrumbs", [
            "Клиенты",
            `${this.client.name} (${this.client.id})`,
          ])

          console.info(response.data)
        })
        .catch((error) => {
          if (error.response && (error.response.status === 404 || error.response.status === 400)) {
            this.error404 = true
          }

          console.warn(error)
        })
    },
    updateClient() {
      this.formDisable = true
      axios
        .post(API_HOST + "/v1/manager/client/" + this.$route.params.id, this.client, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + this.$store.getters.getTokenPair.access,
          },
        })
        .then((response) => {
          this.formDisable = false

          this.client = response.data
          this.notification.success("Сохранено")

          console.info(response)
        })
        .catch((error) => {
          this.formDisable = false
          if (error.response) {
            this.notification.error(error.response.data.message)
          } else {
            this.notification.error("Неизвестная ошибка")
          }

          console.warn(error)
        })
    },
  },
  mounted() {
    this.loadClient()
    setTooltip()
  },
  beforeUnmount() {
    this.$store.commit("setBreadcrumbs", [])
  },
}
</script>

<style scoped></style>